import { render, staticRenderFns } from "./productSummaryChart.vue?vue&type=template&id=9dbc5b0e&"
import script from "./productSummaryChart.vue?vue&type=script&lang=js&"
export * from "./productSummaryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports